document.addEventListener('DOMContentLoaded', async function () {
  try {
    var is_verified = null;
    let user_can_bypass = false;
    const product_auction_id = document.querySelector('[data-auction-id]').getAttribute('data-auction-id');

    const customer_id = window.shopifyCustomerID;

    if (customer_id) {
      const fetch_is_verified = await window.customerApi.getVerification(customer_id);
      const response = await fetch_is_verified.json();
      if (response.data) {
        is_verified = response.data.is_verified || false;
        user_can_bypass = response.data.can_bypass_blocks || false;
      }
    }

    const restricted = await window.globalApi.isCountryRestricted();

    await handleProductRestrictions(user_can_bypass, restricted);

    // doing this check, otherwise it's fetching all the Auction Data form the API. Which takes time.
    if ( !product_auction_id ) return;
    const { AuctionByProduct, AuctionId } = await fetchAuctionData(product_auction_id);

    if (AuctionByProduct && product_auction_id) {
      renderAuctionPdp(AuctionByProduct, AuctionId);
      // add the pusher event
      window.pusherInstance.subscribe(`auction-${AuctionId}`)
        .bind('auction_bid_update', async function (data) {
          console.log(data);
          const content = {
            title: data.event,
            productImgUrl: data.product_image_url,
            name: data.product_name,
            productUrl: data.product_url,
          }

          try {
            const shouldShowNotification = await window.globalApi.GTRProductNotification(data.product_url);
            if (shouldShowNotification) {
              window.showToast('info', content);
            } else {
              console.log("GTR restrictions apply. Not showing notification.");
            }
          } catch (error) {
            console.error("Error checking GTR accessibility: ", error);
            window.showToast('info', content);
          }

          // window.showToast('info', content);

          setAuctionDataHtml(data.current_price, data.bid_count);

        })

      window.pusherInstance.subscribe(`auction-${AuctionId}`)
        .bind('auction_extended', async function (data) {
          console.log(data);
          const content = {
            title: data.event,
            productImgUrl: data.product_image_url,
            name: data.product_name,
            productUrl: data.product_url,
          }

          try {
            const shouldShowNotification = await window.globalApi.GTRProductNotification(data.product_url);
            if (shouldShowNotification) {
              window.showToast('info', content);
            } else {
              console.log("GTR restrictions apply. Not showing notification.");
            }
          } catch (error) {
            console.error("Error checking GTR accessibility: ", error);
            window.showToast('info', content);
          }
          // window.showToast('info', content);
          countBidRemainingTime(data.new_date);
        })

      window.pusherInstance.subscribe(`auction-${AuctionId}`)
        .bind('auction_ended', async function (data) {
          const content = {
            title: data.event,
            productImgUrl: data.product_image_url,
            name: data.product_name,
            productUrl: data.product_url,
          }

          try {
            const shouldShowNotification = await window.globalApi.GTRProductNotification(data.product_url);
            if (shouldShowNotification) {
              window.showToast('error', content);
            } else {
              console.log("GTR restrictions apply. Not showing notification.");
            }
          } catch (error) {
            console.error("Error checking GTR accessibility: ", error);
            window.showToast('error', content);
          }
          // window.showToast('error', content);
          const auctionPrice = Number((data.auction_price / 100).toFixed(2));
          const currentBids = await getCurrentAuctionBids(AuctionId);
          const auctionData = await window.auctionApi.getBids(AuctionId);
          const AuctionProduct = await auctionData.json();
          const bidCount = AuctionProduct.meta.bids_count;
          const hasBidded = currentBids.length > 0;
          const hasBid = bidCount > 0;
          window.setAuctionInPdp('Auction Ended', hasBidded, hasBid, data.product_url);
          updateHammerPrice(auctionPrice);
        })
    }

    const confirmModal = document.getElementById("confirm_bid_modal");

    const confirmbidClose = document.querySelector("#confirm_bid_modal .confirm_bidClose");
    const confirmbidCloseNo = document.querySelector("#confirm_bid_modal .closebutton");
    const confirmbidConfirm = document.querySelector("#confirm_bid_modal .confirm");
    if (is_verified) {
      const verifiedWrapper = confirmModal.querySelectorAll('.is-verified-wrapper');
      verifiedWrapper.forEach(element => {
        element.classList.remove('hidden');
      })

      confirmModal.querySelector('.not-verified-wrapper').classList.add('hidden');
      confirmbidCloseNo.addEventListener('click', () => {
        confirmModal.style.visibility = "hidden";
      })

      confirmbidConfirm.addEventListener('click', async () => {
        const firstName = document.getElementById('customer_header_info').dataset.firstName;
        const lastName = document.getElementById('customer_header_info').dataset.lastName;
        const emailAddress = document.getElementById('customer_header_info').dataset.email;
        const customerID = document.getElementById('customer_header_info').dataset.id;
        const amount = document.querySelector('[name="bid_mgs"]').value;
        const productUrl = document.querySelector('product-page').dataset.productHandle;
        try {
          await window.auctionApi
            .placeBid(amount, customerID, firstName, lastName, emailAddress, AuctionId)
            .then(response => response.text())
            .then(async (result) => {
              const resultJson = await JSON.parse(result);
              if (resultJson) {
                const outbid = resultJson.data.attributes.outbid;
                if (!outbid) window.setAuctionInPdp("Winning", true, true, productUrl);
                confirmModal.style.visibility = "hidden";
                setYourMaxBid(amount);
              }
            })
        } catch (error) {
          console.log('error', error);
        }
      })
    } else {
      const verifiedWrapper = confirmModal.querySelectorAll('.is-verified-wrapper');
      verifiedWrapper.forEach(element => {
        element.classList.add('hidden');
      })
      confirmModal.querySelector('.not-verified-wrapper').classList.remove('hidden');
    }
    confirmbidClose.addEventListener('click', () => {
      confirmModal.style.visibility = "hidden";
    })

    // by default, body is overflow hidden.
    document.body.classList.remove('overflow-hidden');
  } catch (error) {
    console.log('error', error);
  }

  if (document.querySelector('#place_bid')) {
    document.querySelector('#place_bid').addEventListener('click', function () {
      if (document.querySelector('.bid-error')) {
        document.querySelector('.bid-error').remove();
      }
      const bidAmount = Number(document.querySelector("[name='bid_mgs']").value || 0);
      console.log(bidAmount);
      const currentBidValue = Number(document.querySelector('.bid_data .currency_price').dataset.price || 0);
      const errorMsg = document.createElement("span");
      errorMsg.className = "bid-error error warning d-block";
      errorMsg.style = "margin-bottom: 10px";
      document.querySelector('.bid_msg_and_other').style = "margin-bottom: 0px";

      if (bidAmount <= 0) {
        errorMsg.textContent = `Please enter an amount greater than $${currentBidValue} here!`;
        document.querySelector('.bid_msg_and_other input').insertAdjacentElement('afterend', errorMsg);
        document.querySelector('.bid_msg_and_other_mobile input').insertAdjacentElement('afterend', errorMsg);
        return;
      } else if (bidAmount <= currentBidValue) {
        errorMsg.textContent = `Please enter value greater than $${currentBidValue}!`;
        document.querySelector('.bid_msg_and_other input').insertAdjacentElement('afterend', errorMsg);
        document.querySelector('.bid_msg_and_other_mobile input').insertAdjacentElement('afterend', errorMsg);
        return;
      } else if (Number.isInteger(bidAmount) === false) {
        errorMsg.textContent = `Please select a valid value. The two nearest valid values are ${parseInt(bidAmount) + 1} and ${parseInt(bidAmount) + 2}.`;
        document.querySelector('.bid_msg_and_other input').insertAdjacentElement('afterend', errorMsg);
        document.querySelector('.bid_msg_and_other_mobile input').insertAdjacentElement('afterend', errorMsg);
        return;
      }
      if (document.querySelector(".bid-error")) {
        document.querySelectorAll(".bid-error").forEach(el => {
          el.remove();
        })
        document.querySelector('.bid_msg_and_other').style = "margin-bottom: 14px";
      }

      const confirmModal = document.getElementById("confirm_bid_modal");
      confirmModal.style.visibility = "visible";
      const modal_bid_wrapper = confirmModal.querySelectorAll('.your-bid');
      modal_bid_wrapper.forEach(wrapper => {
        wrapper.textContent = ` $${bidAmount.toLocaleString("en-US")}`;
      })
    });
  }
});

async function handleProductRestrictions(canBypass, is_restricted) {
  const product_isGtr = document.querySelector('product-page[data-is-gtr]')?.getAttribute('data-is-gtr');
  const preloader = document.querySelector('.preloader.restricted');
  const breadcrumbEl = document.querySelector('.product_breadcrumbs_wrapper');
  const restrictedText = document.querySelector('.restricted.text');
  const mainProduct = document.querySelector('.product.restricted');

  // Helper function to remove elements
  function removeElement(element) {
    if (element) element.remove();
  }

  // Helper function to remove multiple classes from an element
  function removeClasses(element, ...classes) {
    if (element) element.classList.remove(...classes);
  }

  // we are not using country restriction anymore, because gtr products are hidden globally.
  if (product_isGtr == 'true') {
    if (is_restricted && canBypass == false) {
      removeClasses(restrictedText, 'hidden');
      removeElement(mainProduct);
      removeElement(breadcrumbEl);
      removeElement(preloader);
    } else {
      removeElement(restrictedText);
      removeClasses(breadcrumbEl, 'hidden', 'restricted');
      removeClasses(mainProduct, 'hidden', 'restricted');
      removeElement(preloader);
    }
    // by default, body is overflow hidden.
    document.body.classList.remove('overflow-hidden');
    return;
  }
  removeElement(restrictedText);
  removeClasses(breadcrumbEl, 'hidden', 'restricted');
  removeClasses(mainProduct, 'hidden', 'restricted');
  removeElement(preloader);
  // by default, body is overflow hidden.
  document.body.classList.remove('overflow-hidden');
}

var bidInterval = null;

async function fetchAuctionData(id) {
  const FetchAuctionByProduct = await window.auctionApi.getByAuctionIds(id, window.getCustomerId());
  const AuctionByProduct = await FetchAuctionByProduct.json();

  if (AuctionByProduct.data.length) {
    const AuctionId = AuctionByProduct.data[0].id;
    return { AuctionByProduct, AuctionId };
  }
  return { AuctionByProduct: null, AuctionId: null };
}

function setYourMaxBid(amount) {
  document.querySelector('.your_max_bids .currency_price').innerHTML = '';
  document.querySelector('.your_max_bids .currency_price').dataset.price = amount;
  document.querySelector('.your_max_bids .currency_price').innerHTML = `$ ${amount.toLocaleString('en-US')} <small class="bid_history_text">${Shopify.currency.active}</small>`;
}

function setAuctionDataHtml(currentPrice, bidCount, maxBid) {
  console.log(maxBid);
  document.querySelector('.bid_data .currency_price').innerHTML = '';
  document.querySelector('.bid_data .currency_price').dataset.price = currentPrice;
  document.querySelector('.bid_data .currency_price').innerHTML = `$ ${currentPrice.toLocaleString('en-US')} <small class="bid_history_text">${Shopify.currency.active}</small>`;

  if (maxBid >= 0) {
    setYourMaxBid(maxBid);
  }

  document.querySelector('.bid_data .bid_history_cout').innerHTML = bidCount;
  if (bidCount > 1) {
    document.querySelector('.bid_history .bid_history_text').innerHTML = 'Bids';
  } else {
    document.querySelector('.bid_history .bid_history_text').innerHTML = 'Bid';
  }
  document.querySelector('.bid_msg_and_other label').innerHTML = `Enter $${(currentPrice + 1).toLocaleString('en-US')} or more`;
  document.querySelector('label.bid-label').innerHTML = `Enter $${(currentPrice + 1).toLocaleString('en-US')} or more`;
  document.querySelector('[name="bid_mgs"]').setAttribute('min', currentPrice + 1);
}

async function getCurrentAuctionBids(AuctionId) {
  const FetchBids = await window.auctionApi.getBids(AuctionId);
  const Bids = await FetchBids.json();
  const customerID = window.shopifyCustomerID;
  return await Bids.data.filter(el => {
    return el.attributes.platform_customer_id == customerID;
  })
}

async function renderAuctionPdp(AuctionByProduct, AuctionId) {
  const CurrentPrice = AuctionByProduct.data[0].attributes.current_price;
  const BidCount = AuctionByProduct.data[0].attributes.bids_count;
  const hasEnded = AuctionByProduct.data[0].attributes.auction_has_ended;
  const hammerPrice = AuctionByProduct.data[0].attributes.hammer_price;
  const enddate = AuctionByProduct.data[0].attributes.end_date;
  const currentUserBid = AuctionByProduct.data[0].attributes.current_user_bid;
  const maxBid = currentUserBid ? currentUserBid.amount : 0;
  const productHandle = AuctionByProduct.data[0].attributes.product_url;
  document.querySelector('.bid_history').dataset.auctionId = AuctionId;
  setAuctionDataHtml(CurrentPrice, BidCount, maxBid);

  let bid_state = "";
  if (!hasEnded) {
    bid_state = "Auction Live";
    // Set the date we're counting down to
    countBidRemainingTime(enddate);
  } else {
    bid_state = "Auction Ended";
    await viewAfterAuctionEnded(enddate, "End Date/Time:");
    updateHammerPrice(hammerPrice);
  }

  if (currentUserBid) {
    const isOutBid = currentUserBid.outbid;

    if (hasEnded) {
      if (isOutBid) {
        bid_state = "Auction Lost";
      } else {
        bid_state = "Auction Won";
      }
    } else {
      if (isOutBid) {
        bid_state = "Outbid";
      } else {
        bid_state = "Winning";
      }
    }
  }
  const hasBidded = Boolean(currentUserBid);
  const hasBid = BidCount > 0;
  window.setAuctionInPdp(bid_state, hasBidded, hasBid, productHandle);
}

window.setAuctionInPdp = function setAuctionState(auction_state, hasBidded, hasBid, productHandle) {
  const productPage = document.querySelector(`product-page[data-product-handle='${productHandle}']`);
  console.log(auction_state, hasBidded, hasBid, productHandle);
  let timeLeftDiv = productPage?.querySelector('.time_left_pdp');
  let productAddBtn = productPage?.querySelector('#product-add-button');
  let hasBuynowTag = productAddBtn?.dataset.hasBuynowTag;
  let hasAuctionTag = productAddBtn?.dataset.hasAuctionTag;
  let hasWinnerTag = productAddBtn?.dataset.hasWinnerTag;
  let is_avaibale = productAddBtn?.dataset.is_avaibale;
  if (timeLeftDiv) {
    if (timeLeftDiv.classList.contains('won')) timeLeftDiv.classList.remove('won');
    if (timeLeftDiv.classList.contains('lost')) timeLeftDiv.classList.remove('lost');
    if (timeLeftDiv.classList.contains('ended')) timeLeftDiv.classList.remove('ended');
    if (timeLeftDiv.classList.contains('active')) timeLeftDiv.classList.remove('active');
    if (timeLeftDiv.classList.contains('outbid')) timeLeftDiv.classList.remove('outbid');
    if (timeLeftDiv.classList.contains('not_loaded')) timeLeftDiv.classList.remove('not_loaded');

    switch (auction_state) {
      case "Auction Won":
        timeLeftDiv.classList.add('won');
        timeLeftDiv.innerHTML = "";
        timeLeftDiv.innerHTML = `<img src="//www.emedals.com/cdn/shop/t/101/assets/auction-won.png?v=63374821140401959361741280211" loading="lazy" width=15 height=15 /><span class="time_left_text">Auction Won</span>`
        productPage.querySelector('.bid-wrapper').classList.add('hidden');
        productPage.classList.add('auction-won');
        productPage.querySelector('.bid_msg_and_other').classList.add('hidden');
        productPage.querySelector('.bid_msg_and_other').classList.remove('desktop_view');
        productPage.querySelector('.normal-wrapper').classList.remove('hidden');
        if (is_avaibale == 'false') {
          productAddBtn.setAttribute('disabled', true);
          productAddBtn.textContent = 'Purchased';
        } else {
          productAddBtn.textContent = 'Checkout';
        }
        break;

      case "Auction Lost":
        timeLeftDiv.classList.add('lost');
        timeLeftDiv.innerHTML = "";
        timeLeftDiv.innerHTML = `<img src="//www.emedals.com/cdn/shop/t/101/assets/auction-lost.png?v=142890051665423626681741280210" loading="lazy" width=15 height=15 /><span class="time_left_text">Auction Lost</span>`
        productPage.querySelector('.normal-wrapper').classList.add('disabled');
        productAddBtn.setAttribute('disabled', true);
        productAddBtn.innerHTML = '';
        productAddBtn.innerHTML = 'Lost'
        productPage.querySelector('.bid-wrapper').classList.add('hidden');
        productPage.classList.add('auction-lost');
        productPage.querySelector('.bid_msg_and_other').classList.add('hidden');
        productPage.querySelector('.bid_msg_and_other').classList.remove('desktop_view');
        productPage.querySelector('.normal-wrapper').classList.remove('hidden');
        if (productPage.querySelector('.price')) {
          productPage.querySelector('.price').classList.add('hidden');
        }
        break;

      case "Auction Ended":
        const hasWon = productPage.classList.contains('auction-won');
        const hasLost = productPage.classList.contains('auction-lost');
        if (hasWon) {
          timeLeftDiv.classList.add('won');
        }
        if (hasLost) {
          timeLeftDiv.classList.add('lost');
        }
        if (!hasBidded) {
          timeLeftDiv.classList.add('ended');
          timeLeftDiv.innerHTML = "";
          timeLeftDiv.innerHTML = `<img src="//www.emedals.com/cdn/shop/t/101/assets/auction-ended.png?v=3743771452866791851741280209" loading="lazy" width=15 height=15 /><span class="time_left_text">Auction Ended</span>`
          productPage.querySelector('.normal-wrapper').classList.add('disabled');
          if (hasBid == false && hasAuctionTag == 'true') {
            productAddBtn.innerHTML = '';
            productAddBtn.setAttribute('disabled', true);
            productAddBtn.innerHTML = 'Passed';
          } else
            if ((hasBuynowTag == 'false' && hasBid == false) || (hasBuynowTag == 'true' && is_avaibale == 'false') || (hasBuynowTag == 'false' && hasWinnerTag == 'false')) {
              productAddBtn.innerHTML = '';
              productAddBtn.setAttribute('disabled', true);
              productAddBtn.innerHTML = 'Sold'
            } else if (hasBuynowTag == 'true' && is_avaibale == 'true') {
              productPage.querySelector('.normal-wrapper').classList.remove('disabled');
              productPage.querySelector('.price').classList.remove('hidden');
              productPage.querySelector('.time_left_pdp').remove();
            }
          productPage.querySelector('.bid-wrapper').classList.add('hidden');
          productPage.querySelector('.bid_msg_and_other').classList.add('hidden');
          productPage.querySelector('.bid_msg_and_other').classList.remove('desktop_view');
          productPage.querySelector('.normal-wrapper').classList.remove('hidden');
        }
        break;

      case "Winning":
        if (productPage.querySelector('.price')) {
          productPage.querySelector('.price').classList.add('hidden');
        }
        timeLeftDiv.classList.add('active');
        timeLeftDiv.innerHTML = "";
        timeLeftDiv.innerHTML = `<div class="ring-container">
      <div class="circle"></div>
      <div class="ringring"></div>
      </div><span class="time_left_text">Winning</span>`
        break;

      case "Outbid":
        timeLeftDiv.classList.add('outbid');
        timeLeftDiv.innerHTML = "";
        timeLeftDiv.innerHTML = `<div class="ring-container">
      <div class="circle"></div>
      <div class="ringring"></div>
      </div><span class="time_left_text">Outbid</span>`
        break;

      default:
        break;
    }
  }
}

function onClearBidInterval() {
  clearInterval(bidInterval);
  bidInterval = null;
}

function getDateDiffInDHM(startDate, endDate) {
  const diffMs = Math.abs(endDate.getTime() - startDate.getTime());
  const totalSeconds = Math.floor(diffMs / 1000);
  const totalMinutes = Math.floor(diffMs / (1000 * 60));
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes - days * 24 * 60) / 60);
  const minutes = totalMinutes - days * 24 * 60 - hours * 60;
  const seconds = totalSeconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;
  return { days, hours, minutes, seconds };
}



(document.querySelectorAll('.bid-wrapper input.form-control.mobile_view')).forEach(input => {
  input.addEventListener('keyup', function () {
    document.querySelectorAll('input[name="bid_mgs"]')[0].value = this.value;
  })
});
function getAuctionRemainingTime(end_date) {
  var dateStart = new Date();
  var dateEnd = new Date(end_date);
  if (dateEnd <= dateStart) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
  return getDateDiffInDHM(dateStart, dateEnd);
}


async function updateHammerPrice(hammerPrice) {
  const bid_wrapper = document.querySelector('.current_bids');
  const bid_label = bid_wrapper.querySelector('.type_label');
  const bid_data = bid_wrapper.querySelector('.bid_data');

  bid_label.innerHTML = "Hammer Price:";
  bid_data.innerHTML = `<span class="currency_price" data-price="${hammerPrice.toLocaleString("en-US")}">$ ${hammerPrice.toLocaleString("en-US")} <small class="bid_history_text">${Shopify.currency.active}</small></span>`;
  bid_data.style.textDecoration = "line-through";
}


async function viewAfterAuctionEnded(enddate, label = 'Sale Date:') {
  const remain_time = document.querySelector('.time_remaining');
  const rem_label = remain_time.querySelector('.type_label');
  const sale_date = remain_time.querySelector('.bid_history_cout');
  const bid_history = remain_time.querySelector('.bid_history_text');

  document.querySelector('.pdp_end_date').innerHTML = "";

  const end_date = new Date(enddate);
  const date = end_date.toLocaleDateString('en-us', { weekday: "short", year: "numeric", month: "short", day: "numeric", timeZone: "America/New_York" });
  const time = end_date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' });
  rem_label.textContent = label;
  // get the current timezone
  const timeZoneAbbreviation = await window.globalApi.getTimeZoneAbbreviation() || "";
  const timeZoneAbbreviationHtml = `<span class='time_zone'>${timeZoneAbbreviation}</span>`
  sale_date.innerHTML = date + " " + time + " " + timeZoneAbbreviationHtml;
  bid_history.classList.add('hidden');
}

async function countBidRemainingTime(enddate) {
  var date = new Date(enddate);
  var options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: 'America/New_York',
  };

  let formattedDate = date.toLocaleString('en-US', options);
  document.querySelector('.bid_end_date .bid_date').innerHTML = formattedDate;

  if (enddate) {
    onClearBidInterval();
    // set the initial remaining time
    const { days, hours, minutes, seconds } = getAuctionRemainingTime(enddate);
    setCoundownTime(days, hours, minutes, seconds);
    // start countdown and calculate end date
    // Update the countdown every 1 second
    bidInterval = setInterval(async function () {
      const { days, hours, minutes, seconds } = getAuctionRemainingTime(enddate);
      if ((days === 0 && hours === 0 && minutes === 0 && seconds === 0)) {
        onClearBidInterval();
        await viewAfterAuctionEnded(enddate);
      } else {
        // Display the countdown timer
        setCoundownTime(days, hours, minutes, seconds);
      }
    }, 1000);

    const formatDate = date.toLocaleDateString("en-us", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      timeZone: "America/New_York",
    });
    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });
    const timeZoneAbbreviation = await window.globalApi.getTimeZoneAbbreviation() || "";
    document.querySelector('.pdp_end_date').innerHTML = formatDate + " " + time + " " + timeZoneAbbreviation;
  }
}

function setCoundownTime(days, hours, minutes, seconds) {
  document.getElementById("countdown").innerHTML = "";
  if (days > 0) {
    document.getElementById("countdown").innerHTML = days + "D " + hours + "H";
    document.getElementById("countdown_time_left").innerHTML = "left";
  } else if (hours > 0) {
    document.getElementById("countdown").innerHTML = hours + "H " + minutes + "M";
    document.getElementById("countdown_time_left").innerHTML = "left";
  } else {
    document.getElementById("countdown").innerHTML = minutes + "M " + seconds + "S";
    document.getElementById("countdown_time_left").innerHTML = "left";
  }
}

function wishlistRenderer() {
  getWishlistData();
  const wishlist_button = document.querySelectorAll('[data-action="addToWishlist"]');
  const Active_wishlist_button = document.querySelectorAll('[data-action="removeFromWishlist"]');

  if (wishlist_button) {
    wishlist_button.forEach(button => {
      button.addEventListener('click', async function () {
        const customer_id = window.shopifyCustomerID;
        if (customer_id) {
          const product_id = button.dataset.productId;
          console.log(product_id);
          window.customerApi.addToWishList(customer_id, product_id)
            .then(response => response.text())
            .then((data) => {
              getWishlistData();
            })
            .catch(error => {
              console.log(error);
            })
        } else {
          if (button) {
            button.classList.remove('hidden');
          }
          window.utils.openSigninModal();
        }

      })
    })
  }
  if (Active_wishlist_button) {
    Active_wishlist_button.forEach(button => {
      button.addEventListener('click', async function () {
        const customer_id = window.shopifyCustomerID;
        if (customer_id) {
          const product_id = button.dataset.productId;
          window.customerApi.removeFromWishList(customer_id, product_id)
            .then(response => response.text())
            .then((data) => {
              getWishlistData();
            })
            .catch(error => {
              console.log(error);
            })
        } else {
          const confirmModal = document.getElementById("confirm_account_modal");
          confirmModal.style.visibility = "visible";
        }
      })
    })
  }
}

wishlistRenderer();

async function getWishlistData() {
  const product_id = document.querySelector('product-info[data-product-id]').dataset.productId;
  const wishlist_button = document.querySelectorAll('[data-action="addToWishlist"]');
  const Active_wishlist_button = document.querySelectorAll('[data-action="removeFromWishlist"]');
  const wishlistCounters = document.querySelectorAll('.swym-wish-counter');

  const customer_id = window.shopifyCustomerID;
  if (customer_id) {
    const fetchWishlist = await window.customerApi.getWishList(customer_id)
    const wishlist = await fetchWishlist.json();

    if (wishlist) {
      // console.log(' wishlist.data.products_count -> ', wishlist.data.products_count);
      const wishlistProducts = wishlist.data?.products || {};
      // if (Object.keys(wishlistProducts).length > 0) {
      //   return;
      // }
      const currentProduct = wishlistProducts.filter(product => {
        return product.shopify_product_id == product_id
      });
      if (currentProduct.length) {
        Active_wishlist_button.forEach(button => {
          button.classList.remove('hidden');
        })
        wishlist_button.forEach(button => {
          button.classList.add('hidden');
        })

      } else {
        Active_wishlist_button.forEach(button => {
          button.classList.add('hidden');
        })
        wishlist_button.forEach(button => {
          button.classList.remove('hidden');
        })
      }
      wishlistCounters.forEach(counter => {
        counter.innerHTML = wishlist.data.products_count == 0 ? '' : wishlist.data.products_count;
      })
    } else {
      wishlist_button.forEach(button => {
        button.classList.remove('hidden');
      })
    }
  } else {
    wishlist_button.forEach(button => {
      button.classList.remove('hidden');
    })
  }

}
